import { readInstance } from '../classes/EvaluationStack.js';
export const injectAtomSelector = (selectable, ...args) => {
    const instance = readInstance();
    return instance.ecosystem._evaluationStack.atomGetters.select(selectable, ...args);
};
